import { isFunction } from 'lodash';
import { useEffect, useState } from 'react';

import { useEffectOnlyRunOnFirstMount } from '@/hooks/use-effect-only-on-first-mount';
import { usePorts } from '@/hooks/use-ports';

import { SearchFields } from '../search-fields';

interface PortInsightsSearchProps {
  portFromUrlParam?: string | null;
  placeFromUrlParam?: string | null;
}

const PortInsightsSearch = ({ portFromUrlParam, placeFromUrlParam }: PortInsightsSearchProps) => {
  const { performInitialPortsSearch } = usePorts();
  const [hasLoaded, setHasLoaded] = useState(false);

  const isFirstRender = useEffectOnlyRunOnFirstMount();

  useEffect(() => {
    if (!hasLoaded && isFunction(performInitialPortsSearch)) {
      performInitialPortsSearch({
        portFromUrlParam,
        placeFromUrlParam,
      });
      setHasLoaded(true);
    }
  }, [isFirstRender, performInitialPortsSearch, hasLoaded, portFromUrlParam, placeFromUrlParam]);

  return <SearchFields />;
};

export { PortInsightsSearch };
